<template>
    <div class="empty" :style="`background:url(${bgImg}) no-repeat`">
        <img class="empty-img" :src="src" alt="暂无数据">
        <span class="empty-text">{{text}}</span>
    </div>
</template>

<script>
import noCertImg from "@/assets/images/empty/no-cret.png"
import bgImg from "@/assets/images/empty/background.png"

export default {
    name: 'VEmpty',
    props: {
        src: {
            type: String,
            default: noCertImg
        },
        text: {
            type: String,
            default: "暂无相关数据"
        }
    },
    data () {
        return {
            noCertImg,
            bgImg
        }
    }
}
</script>

<style lang="less">
.empty{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    &-img {
        width: 284px;
        height: 284px;
        margin-bottom: 10px;
    }
    &-text {
        font-size: 14px;
        color: #B6B7B9;
    }

}

</style>


// WEBPACK FOOTER //
// src/components/empty/empty.vue